import i18n from "config/i18next";

i18n.addResources("es", "dashboard", {
  title: "Monitor",
  activeTransactions: "Transacciones activas",
  assignedTransactions: "Transacciones asignadas",
  collectedTransactions: "Transacciones colectadas",
  delayedTransactions: "Transacciones demoradas",
  delayedTrips: "Viajes demorados",
  pointStatus: "Status punto",
  tripId: "Código de viaje",
  pickerId: "ID picker",
  trxAmount: "Cant. trx",
  workzone: "Zona",
  fuo: "FUO",
  picker: "picker",
  minutes: "minutos",
  hours: "horas",
  hour: "hora",
  address: "Dirección",
  workZoneName: "Zona",
  pending: "Pend.",
  assigned: "Asig.",
  idc: "IDC",
  delayedTripsTooltip: "Último movimiento del viaje\nque supere los 45 minutos",
  pointStatusTooltip: "Situación actual\ndel punto pickit",
  slotCapacityTitle: "Capacidad por turno en curso",
  slotCapacityTooltip:
    "Utilizá las regiones para filtrar\nlas zonas de operación ",
  withTrx: "Con trx",
  withoutTrx: "Sin trx",
  disconnected: "Desconectados",
  saturationTitle: "Nivel de saturación",
  saturationTooltip:
    "Revisá cuantas de las transacciones\nestán asignadas a repartidores",
  noResults: "No hay resultados disponibles",
  refresh: "Actualizar",
  changeRegions: "Cambiar regiones",
  expiredSlotTitle: "Nuevo turno disponible",
  expiredSlotBody:
    "La información que estás viendo pertenece a un turno que finalizó",
});
